<template>
    <div class="text-right bg" :style="{height:heights+'px'}">
        <div style="overflow: scroll;" :style="{height:heights+'px'}">
            <div class="dflexs  head">
                <img class="returns" @click='returns' src="../../assets/guild/returnimg.png" alt="">
                <div class="pagetitle">{{$t('guild.guild_certification01')}}</div>
            </div>
            <div class="boxs">
                <div class="pocket">
                    <div class="pockets">
                        Pocket
                    </div>
                    <div class="hint">
                        {{$t('guild.guild_certification02')}}
                    </div>
                </div>
                <div class="requirementsbox" :style="{height:neirongh+'px'}">
                    <div class="rtitlebox ">
                        <div class="flies" style="position: relative;">
                            <img style="margin-right:0.1rem" src="../../assets/guild/decorateL.png" alt="">
                            <div class="rtitle">{{$t('guild.guild_certification03')}}</div>
                            <img style="margin-left:0.1rem" src="../../assets/guild/decorateR.png" alt="">
                        </div>
                        <div class="neirong clear">
                            <div class="contentbox" v-for="(items, index) in $t('guild.guild_certification04')"
                                :key="index">
                                <div class="dian">{{index+1}}</div>
                                <div class="content">{{items}}</div>
                            </div>
                            <span style="display: flex;">
                                <img style="height: 0.196rem;" src="../../assets/guild/segmentation.png" alt="">
                            </span>
                            <div class="tishi">
                                {{$t('guild.guild_certification05')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="requirementsbox" :style="{height:entrymode+'px'}">
                    <div class="rtitlebox ">
                        <div class="flies" style="position: relative;">
                            <img style="margin-right:0.1rem" src="../../assets/guild/decorateL.png" alt="">
                            <div class="rtitle">{{$t('guild.guild_certification07')}}</div>
                            <img style="margin-left:0.1rem" src="../../assets/guild/decorateR.png" alt="">
                        </div>
                        <div class="neirong entrymode ">
                            <div class="contentbox" style="align-items: center;padding-bottom: 0.358rem;"
                                v-for="(item, index) in guildContact" :key="index">
                                <div class="dian" style="margin-top: 0">{{index+1}}</div>
                                <div v-if="$i18n.locale=='ar'" class="content"
                                    style="flex-grow: 1;line-height: initial">{{item.contacts}}
                                    :{{item.type==0?'WhatsApp':'Facebook'}}</div>
                                <div v-else class="content" style="flex-grow: 1;line-height: initial">
                                    {{item.type==0?'WhatsApp':'Facebook'}}: {{item.contacts}}</div>
                                <div class="copy" @click="copyThat(item.contacts)">{{$t('guild.guild_certification08')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import $ from "jquery";
    import { Toast } from "vant";
    import axios from "axios";
    import Cookies from 'js-cookie';
    export default {
        name: "App",
        components: {
            // HelloWorld
        },
        data() {
            return {
                heights: 0,
                neirongh: 0,
                entrymode: 0,
                huadong: 0,
                token: null,
                uid: null,
                headers: null,
                // token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOREV5IiwieHl6IjoiWmpsalpEUTVZakpqT0daaU5HTmlNV0ZpTnpWbFkyWmlNell3WmpnNVlqVT0iLCJleHAiOjE5MDc3NDM3NDB9.irA-gNwNYSD9s6_BQH2nwiQU8Zprq5BS2nyHhqwIRYY',
                // uid: 412,
                // headers: [
                //     'Content-Type:' + 'application/json; charset=utf-8',
                //     'deviceId:' + 'f9cd49b2c8fb4cb1ab75ecfb360f89b5',
                //     'lang:' + 'zh_CN',
                //     'version:' + '1.0.2',
                //     'os:' + '1',
                //     'model:' + 'M2011K2C',
                //     'fid:' + '0',
                // ],
                userInfo: [],
                guildContact: null

            };
        },
        created() {
            this.$completes.complete("getUserInfo");
            window.getUserInfo = this.getUserInfo
            window['getUserInfo'] = (data) => {
                this.getUserInfo(data);
            }
        },
        mounted() {
            this.heights = window.screen.height
            // this.helplist()
            // this.$i18n.locale = 'zh'
            // document.querySelector('html').setAttribute('lang', this.$i18n.locale);
            // document.getElementsByTagName("html")[0].style.backgroundColor = "#8260FF";
            document.getElementsByTagName("html")[0].style.padding = "0";
            var neirong = document.getElementsByClassName('neirong');
            var entrymode = document.getElementsByClassName('entrymode');
            var pocket = document.getElementsByClassName('pocket');
            var rtitlebox = document.getElementsByClassName('rtitlebox');
            this.neirongh = neirong[0].offsetHeight + rtitlebox[0].offsetHeight + 3.5
            this.entrymode = entrymode[0].offsetHeight + rtitlebox[0].offsetHeight
            $(window).scroll(function (e) {
                let opacity = $(document).scrollTop() / 80;
                opacity = opacity > 100 ? 100 : opacity.toFixed(2);//渐变色从0到1
                $('.head').css({ 'background': 'rgba(255, 255, 255,' + opacity + ')' })
            })
        },
        methods: {
            //返回
            returns() {
                this.$completes.complete("getPreviousPage");
            },

            getUserInfo(data) {
                let that = this
                this.userInfo = JSON.parse(data);
                this.headers = [
                    'Content-Type:' + 'application/json; charset=utf-8',
                    'deviceId:' + JSON.parse(data).deviceId,
                    'lang:' + JSON.parse(data).lang,
                    'version:' + JSON.parse(data).version,
                    'os:' + JSON.parse(data).os,
                    'model:' + JSON.parse(data).model,
                    'fid:' + JSON.parse(data).fid
                ]
                this.token = JSON.parse(data).token
                this.uid = JSON.parse(data).userId
                // this.serviceIp = JSON.parse(data).serviceIp
                let langs = this.userInfo.lang.substring(0, 2)
                let lang = this.userInfo.lang
                if (langs == 'zh') {
                    if (lang == 'zh_TW' || lang == 'zh_HK') {
                        this.$i18n.locale = 'tc'
                    }
                    else {
                        this.$i18n.locale = 'zh'
                    }
                }
                else if (langs == 'en') {
                    this.$i18n.locale = 'en'
                }
                else if (langs == 'ar') {
                    this.$i18n.locale = 'ar'
                }
                else {
                    this.$i18n.locale = 'en'
                }
                document.title = this.$t('guild.guild_certification01')
                document.querySelector('html').setAttribute('lang', this.$i18n.locale);
                this.contact()
            },

            contact() {
                let that = this
                let paramObjs = {
                    option: 'get',
                    host: this.$serviceIp + 'api/code/GuildAnchorAdmin/guildApproveContacts?token=' + that.token + '&uid=' + that.uid,
                    data: '',
                    header: JSON.stringify(this.headers),
                };
                this.$server.curlExec(paramObjs).then((data) => {
                    if (data.code == 200) {
                        this.guildContact = JSON.parse(data.data)
                        setTimeout(() => {
                            var neirong = document.getElementsByClassName('neirong');
                            var entrymode = document.getElementsByClassName('entrymode');
                            var pocket = document.getElementsByClassName('pocket');
                            var rtitlebox = document.getElementsByClassName('rtitlebox');
                            this.neirongh = neirong[0].offsetHeight + rtitlebox[0].offsetHeight + 3.5
                            this.entrymode = entrymode[0].offsetHeight + rtitlebox[0].offsetHeight
                            this.heights = this.neirongh + this.entrymode + pocket[0].offsetHeight + 88 + 50
                            if (window.screen.height > this.heights) {
                                this.heights = window.screen.height
                            }
                        }, 150);
                    }
                    else {
                        Toast(data.message || this.$t('transfer.error'))
                    }
                })
            },

            //copy code
            copyThat(data) {
                let url = data;
                let oInput = document.createElement('input');
                oInput.value = url;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象;
                document.execCommand("Copy"); // 执行浏览器复制命令
                Toast(this.$t('guild.guild_certification06'))
                oInput.remove()
            },
            // //原生调用方法

        },

    };

</script>

<style>
    /* html[lang="ar"] .text-right {
  text-align: right;
}

html[lang="zh"] .text-left {
  text-align: left;
} */

    /* .taskbox {
    left: 0;
    right: 0;
  } */

    html[lang="ar"] .text-right {
        direction: rtl;
    }

    html[lang="ar"] .returns {
        -webkit-transform: rotateY(180deg);
    }


    html[lang="ar"] .pagetitle {
        padding-left: 0.4rem;

        padding-right: 0;
    }

    html[lang="ar"] .dian {
        margin-left: 0.145rem;
        margin-right: 0
    }

    html[lang="ar"] .content {
        direction: ltr;
        text-align: right;
    }

    .flies {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .bg {
        background: url("../../assets/guild/bg.png");
        background-size: 100% 100%;
        background-attachment: fixed;
        overflow: hidden;
    }

    .head {
        display: flex;
        align-items: center;

        justify-content: center;
        padding: 0 0.27rem;
        height: 44px;
        margin: 0 !important;
        position: fixed;
        left: 0;
        right: 0;
        z-index: 999;
        top: 0;
        padding-top: 44px;
    }

    .boxs {
        position: absolute;
        left: 0;
        right: 0;
        margin-top: 88px;
        padding: 0.64rem 0.27rem 0 0.27rem;
    }

    .pagetitle {
        font-size: 0.3rem;
        font-family: Mediums;
        color: #000000;
        flex: 1;
        text-align: center;
        padding-right: 0.4rem;
    }

    .returns {
        width: 0.4rem;
        height: 0.4rem;
    }

    .pockets {
        color: #000000;
        font-family: Mediums;
        font-size: 0.51rem;
        font-weight: 600;
    }

    .hint {
        color: #000000;
        font-family: Regulars;
        font-size: 0.27rem;
        padding-bottom: 0.58rem;
    }

    .requirementsbox {}

    .rtitlebox {
        background: url("../../assets/guild/tops.png");
        background-size: 100% 100%;
        padding: 0.28rem 0.66rem 0.44rem 0.66rem;
    }

    .rtitle {
        font-size: 0.26rem;
        font-family: Mediums;
        line-height: 1;
    }

    .rtitlebox img {
        height: 0.19rem;
    }

    .neirong {
        position: absolute;
        left: 0;
        right: 0;
        padding: 29px 0.27rem 0;
        background: #fff;
        margin: 0.22rem 0.27rem 0 0.27rem;
        border-radius: 0.2rem;
    }

    .contentbox {
        display: flex;
        padding-bottom: 0.33rem;


    }

    .content {
        font-size: 0.22rem;
        font-family: Regulars;
        color: #000000;
        line-height: 0.3rem;
        /* padding: 0.245rem 0 0 0; */
    }

    .dian {
        width: 0.256rem;
        height: 0.256rem;
        background: #83E1B6;
        border-radius: 50%;
        min-width: 0.256rem;
        min-height: 0.256rem;
        color: #FFFFFF;
        font-size: 0.2rem;
        font-family: Regulars;
        margin-right: 0.145rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.03rem;
    }


    .copy {
        /* background: #5dc48a; */
        color: #5dc48a;
        padding: 0.07rem 0.22rem;
        border-radius: 24px;
        line-height: 1;
        font-size: 0.188rem;
        font-family: Regulars;
        border: 1px solid #5DC48A;
    }

    .tishi {
        color: #B0B6B6;
        font-size: 0.22rem;
        font-family: Regulars;
        padding: 0.3rem 0 0.589rem 0;

    }

    .clear {
        clear: both;
    }
</style>